// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tBtoqHcsD6cn_BnuxIUJ{flex-direction:column;align-items:flex-start;width:100%;max-width:532px;margin:0 auto;padding:30px 20px 0;display:flex}.BCd42Mme0e8o3v1eO3Pb{margin-top:24px}.Wj2GXtryBEsBunZ_YJwS{border-radius:6px;width:100%;height:4px;margin-top:16px}.rUgHatz8eo0d7DgVVIO8{margin-top:20px}.MOweioXkI0B_KIBllBAE{gap:8px;margin-top:20px;display:flex}.hK6GpYthv5wc3HsLxWgU{color:rgba(255,255,255,.7)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"continue": `tBtoqHcsD6cn_BnuxIUJ`,
	"title": `BCd42Mme0e8o3v1eO3Pb`,
	"progressBar": `Wj2GXtryBEsBunZ_YJwS`,
	"supportingText": `rUgHatz8eo0d7DgVVIO8`,
	"actions": `MOweioXkI0B_KIBllBAE`,
	"stepHint": `hK6GpYthv5wc3HsLxWgU`
};
export default ___CSS_LOADER_EXPORT___;
